import { useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  arrowContainer: {
    position: 'relative',
    width: '60px',
    height: '40px',
  },
  arrow: {
    position: 'absolute',
    top: '9.7px',
    left: '-2px',
    width: '90px',
    [theme.breakpoints.down('sm')]: {
      top: '10px',
    },
  },
}));

export const ArrowIcon = () => {
  const { classes } = useStyles();
  const theme = useTheme();
  return (
    <div className={classes.arrowContainer}>
      <div className={classes.arrow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 10"
          preserveAspectRatio="none"
          className="arrow-svg"
        >
          <line x1="0" y1="5" x2="90" y2="5" stroke={theme.palette.primary.light} strokeWidth="3" />
          <polygon points="90,0 100,5 90,10" fill={theme.palette.primary.light} />
        </svg>
      </div>
    </div>
  );
};
